import axios from 'axios'
import { bus } from '@/utils/bus'
import { Message } from 'element-ui'

let language = 'en'

const service = axios.create({
    baseURL: 'https://komo-admin.cuangezhan.com/api/app/', // 自己项目中请求地址前缀部分
    // baseURL: 'https://komo-admin.cuangezhan.com/api/app/', http://192.168.1.71:8082/api/app/
    timeout: 200000, // 请求超时时间毫秒
    // withCredentials: true, // 异步请求携带cookie
    headers: {
        // 设置后端需要的传参类型
        'Content-Type': 'application/json'
    },
})
console.log(service.defaults.headers.language)

// 添加请求拦截器
// service.interceptors.request.use(
//     function (config) {
//         const users = useUserStore()
//         // 在发送请求之前做些什么
//         config.headers['X-Access-Token'] = users.getToken()
//         return config
//     },
//     function (error) {
//         // 对请求错误做些什么
//         console.log('发出请求前出错了', error)
//         return Promise.reject(error)
//     }
// )

// 添加响应拦截器
// 监听语言变更
bus.$on('locale-change', (newLocale) => {
    console.log('HTTP模块收到语言变更:', newLocale)
    language = newLocale;
})
// 请求拦截器 - 每次请求时动态设置语言
service.interceptors.request.use(
    function (config) {
        // 动态设置语言header
        config.headers['language'] = convertFirstLetterToLower(language)
        console.log('当前请求语言设置:', language) // 添加调试信息
        return config
    },
    function (error) {
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    function (response) {
        //console.log('响应了',response)

        // 这个地方响应了数据该做点什么 做想做的事情
        // dataAxios 是 axios 返回数据中的 data
        const dataAxios = response.data
        // 这个状态码是和后端约定的
        // const code = dataAxios.reset
        return dataAxios
    },
    function (error) {
        // 对响应错误做点什么
        console.log('出错了', error)
        if (error.response && error.response.status === 404) {
            Message({
                showClose: true,
                message: '接口未找到',
                type: 'error',
            })
            return new Promise(() => { }) // pending的promise，中止promise链
        }
        if (error.response && error.response.status === 500) {
            Message({
                showClose: true,
                message: error.response.statusText||error.response.data.message,

                type: 'error',
            })
            return new Promise(() => { }) // pending的promise，中止promise链
        }
        if (error.response && error.response.status === 503) {
            Message({
                showClose: true,
                message: '503-服务不可用',
                type: 'error',
            })
            return new Promise(() => { }) // pending的promise，中止promise链
        }
        if (error.response && error.response.status === 422) {
            Message({
                showClose: true,
                message: error.response.statusText || error.response.data.message,
                type: 'error',
            })
            return new Promise(() => { }) // pending的promise，中止promise链
        }
        console.log('错误信息', error.response)
        return Promise.reject(error)
    }
)

function convertFirstLetterToLower(str) {
  return str.charAt(0).toLowerCase() + str.slice(1);
}
export default service   //最后暴露出去